import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BaseUI } from '../../base.ui';
import { ConfirmDialog } from '../../dialog/confirm/confirm.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';
import { TestResultInterface } from '../../../../core';

@Component({
    selector: 'thr-test-start-suitability',
    templateUrl: './test-start-suitability.component.html',
    styleUrls: ['./test-start-suitability.component.scss'],
})
export class TestStartSuitabilityComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public showResume = false;

    @Input()
    fullResume = false;

    @Input()
    showCancelButton = false;

    @Input()
    public result: TestResultInterface;

    // tslint:disable-next-line:no-output-native
    @Output()
    public resume: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public repeat: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public cancel: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public next: EventEmitter<boolean> = new EventEmitter();

    constructor(parentEvents: ParentEvents, private dialog: MatDialog) {
        super(parentEvents);
    }

    ngOnInit() {
        this.resume.emit(false);
    }

    onRepeat() {
        const dialogRef = this.dialog.open(ConfirmDialog, {
            data: { text: 'dialog.repeat-test' },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.repeat.emit(true);
            }
        });
    }

    onCancel() {
        this.cancel.emit(true);
    }

    onClick() {
        if (!this.showResume && !!this.result && this.result.testId.value != '99F4CD001F62F1F6EA398417A57A4A29') {
            this.showResume = true;
            this.resume.emit(true);

            this.parentEvents.resize();
        } else if (!this.result || this.result.testId.value == '99F4CD001F62F1F6EA398417A57A4A29') {
            this.repeat.emit(true);
        } else {
            this.next.emit(true);
        }
    }
}
